export const COMPANY_FREE_PLAN_KEY = 'company-free';
export const USER_FREE_PLAN_KEY = 'individual-free';
